import React, {Fragment, useContext, useEffect, useRef, useState} from "react";
import {Form, Card} from "react-bootstrap";
import {InstitutionApiCalls} from "../../../../apis/InstitutionApiCalls";
import {
    CREATION_ROLES,
    INTEGRATION_GUIDE,
    INTEGRATION_TYPES,
    INTEGRATION_TYPES_LOWERCASE,
    ROLE_MAPPING,
    blackboardRoles,
    canvasRoles,
    moodleRoles,
    d2lRoles,
    LTI_USER_MAPPING,
    API_CONFIG,
    USER_CONFIG,
    AUTO_PROVISION_COURSE,
    AUTO_SYNC_COURSE,
    AUTO_SYNC_USER,
    AUTO_PROVISION_USER,
    LTI_FORM_FIELDS,
    LTI_DEFAULT_ENDPOINTS,
    COURSE_CONFIG,
    TEXTBOX,
    INTEG_TEXT_BOX,
    AUTO_PROVISION_USER_DESC,
    AUTO_SYNC_USER_DESC,
    AUTO_PROVISION_COURSE_DESC, AUTO_SYNC_COURSE_DESC
} from "../../../../utils/constants";
import styles from "./LTI3.module.css";
import {YuJaTextBox} from "../../../../components/standardization/YuJaTextBox";
import {YuJaDropdown} from "../../../../components/standardization/YuJaDropdown";
import {YuJaTooltip} from "../../../../components/standardization/YuJaTooltip";
import crossIntegrationLTI from "../../../../images/crossIntegrationLTI.svg";
import roleMapping from "../../../../images/roleMapping.svg";
import userProvisioning from "../../../../images/userProvisioning.svg";
import LTiIcon from "../../../../images/ltiicon.svg";
import generalIcon from "../../../../images/generalIcon.svg";
import Skeleton, {SkeletonTheme} from "react-loading-skeleton";
import {checkLTICompletedNew} from "../../../../utils/helpers";
import {YuJaGlobalState} from "../../../../utils/LoadingContext";
import {ReactComponent as CHECK} from "../../../../images/SmallGreenCheck.svg";
import {ReactComponent as INFO} from "../../../../images/purple_info.svg";
import {ReactComponent as InfoIcon} from "../../../../images/info_icon.svg";
import {AuthenticationApiCalls} from "../../../../apis/AuthenticationApiCalls";
import YuJaSwitch from "../../../../components/standardization/YuJaSwitch";

export default function GeneralLTIPage({
                                           selectedMenu,
                                           canvasForm,
                                           blackboardForm,
                                           d2lForm,
                                           moodleForm,
                                           setD2lForm,
                                           setBlackboardForm,
                                           setCanvasForm,
                                           setMoodleForm,
                                           onLmsFormLoaded = () => {}
                                       }) {
    const [loaded, setLoaded] = useState(false);
    const {getSSODetails} = InstitutionApiCalls();
    const [loading, setLoading] = useState(false);
    const [launchCountLoaded, setLaunchCountLoaded] = useState(false);
    const {globalHostResource} = useContext(YuJaGlobalState);
    const [isLTICompleted, setIsLTICompleted] = useState(false);
    const [launchCount, setLaunchCount] = useState(0);
    let {countLMSLaunch} = AuthenticationApiCalls();
    let curIntType = useRef("");

    const getIntegrationType = () => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            return INTEGRATION_TYPES.BLACKBOARD
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            return INTEGRATION_TYPES.CANVAS
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            return INTEGRATION_TYPES.MOODLE
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            return INTEGRATION_TYPES.D2L
        }
    };

    const getSSOMap = (ssoMap) => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            return ssoMap.BLACKBOARD
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            return ssoMap.CANVAS
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            return ssoMap.MOODLE
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            return ssoMap.D2L
        }
    };

    const fetchData = (intType) => {
        setLoading(true);
        getSSODetails().then(result => {
            let ssoMap = result.ssoConfig;
            const ssoConfigData = JSON.parse(
                ssoMap.hasOwnProperty(getIntegrationType())
                    ? getSSOMap(ssoMap)
                    : "{}"
            );
            if (
                ssoConfigData !== "undefined" ||
                ssoConfigData.propertyIsEnumerable()
            ) {
                if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
                    setBlackboardForm(ssoConfigData);
                    onLmsFormLoaded(INTEGRATION_TYPES.BLACKBOARD, ssoConfigData);
                } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
                    setCanvasForm(ssoConfigData);
                    onLmsFormLoaded(INTEGRATION_TYPES.CANVAS, ssoConfigData);
                } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
                    setMoodleForm(ssoConfigData);
                    onLmsFormLoaded(INTEGRATION_TYPES.MOODLE, ssoConfigData);
                } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
                    setD2lForm(ssoConfigData);
                    onLmsFormLoaded(INTEGRATION_TYPES.D2L, ssoConfigData);
                }
            }
        }).finally(() => setLoading(false));

        setLaunchCountLoaded(false);
        countLMSLaunch(intType).then(count => {
            if (intType === curIntType.current) {
                setLaunchCount(count);
            }
        }).finally(() => {
            if (intType === curIntType.current) {
                setLaunchCountLoaded(true);
            }
        });
    };

    useEffect(() => {
        let intType = getIntegrationType();
        setIsLTICompleted(checkLTICompletedNew(globalHostResource, intType));
        curIntType.current = intType;
        fetchData(intType);
        setLoaded(true);
        if (document.getElementById("lmsLastElem") != null) {
            document.getElementById("lmsLastElem").addEventListener('keydown', function (e) {
                if (e.key === 'Tab' && !e.shiftKey && document.getElementById("integrationSaveBtn")) {
                    e.preventDefault();
                    document.getElementById('integrationSaveBtn').focus();
                }
            });
        }
    }, [loaded, selectedMenu]);

    useEffect(() => {
        if (loading) {
            return;
        }
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            const {oidcEndpoint, jwksEndpoint} = LTI_DEFAULT_ENDPOINTS.CANVAS;
            if (canvasForm.oidcEndpoint !== oidcEndpoint || canvasForm.jwksEndpoint !== jwksEndpoint) {
                setCanvasForm({...canvasForm, oidcEndpoint, jwksEndpoint});
            }
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            const {oidcEndpoint, oAuth2Endpoint, getJwksEndpoint} = LTI_DEFAULT_ENDPOINTS.BLACKBOARD;
            const jwksEndpoint = getJwksEndpoint(blackboardForm.clientId);
            if (blackboardForm.oidcEndpoint !== oidcEndpoint || blackboardForm.oAuth2Endpoint !== oAuth2Endpoint || blackboardForm.jwksEndpoint !== jwksEndpoint) {
                setBlackboardForm({...blackboardForm, oidcEndpoint, oAuth2Endpoint, jwksEndpoint});
            }
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            const {oAuth2Endpoint, getOidcEndpoint, getJwksEndpoint} = LTI_DEFAULT_ENDPOINTS.D2L;
            const oidcEndpoint = getOidcEndpoint(d2lForm.iss);
            const jwksEndpoint = getJwksEndpoint(d2lForm.iss);
            if (d2lForm.oidcEndpoint !== oidcEndpoint || d2lForm.jwksEndpoint !== jwksEndpoint || d2lForm.oAuth2Endpoint !== oAuth2Endpoint) {
                setD2lForm({...d2lForm, oidcEndpoint, jwksEndpoint, oAuth2Endpoint});
            }
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            const {getOidcEndpoint, getJwksEndpoint, getOAuth2Endpoint} = LTI_DEFAULT_ENDPOINTS.MOODLE;
            const oidcEndpoint = getOidcEndpoint(moodleForm.iss);
            const jwksEndpoint = getJwksEndpoint(moodleForm.iss);
            const oAuth2Endpoint = getOAuth2Endpoint(moodleForm.iss);
            if (moodleForm.oidcEndpoint !== oidcEndpoint || moodleForm.jwksEndpoint !== jwksEndpoint || moodleForm.oAuth2Endpoint !== oAuth2Endpoint) {
                setMoodleForm({...moodleForm, oidcEndpoint, jwksEndpoint, oAuth2Endpoint});
            }
        }
    }, [
        loading,
        selectedMenu,
        canvasForm.oidcEndpoint,
        canvasForm.jwksEndpoint,
        blackboardForm.clientId,
        blackboardForm.oidcEndpoint,
        blackboardForm.jwksEndpoint,
        blackboardForm.oAuth2Endpoint,
        d2lForm.iss,
        d2lForm.oidcEndpoint,
        d2lForm.jwksEndpoint,
        d2lForm.oAuth2Endpoint,
        moodleForm.iss,
        moodleForm.oidcEndpoint,
        moodleForm.jwksEndpoint,
        moodleForm.oAuth2Endpoint,
    ]);

    const isFieldFilled = (value) => !!(value && value.trim() !== "");

    const handleBlackboardFormChange = (e) => {
        const input = e.currentTarget;
        const blackboardFormConst = Object.assign({}, blackboardForm);
        if (input.type === "checkbox") {
            blackboardFormConst[input.name] = input.checked;
        } else {
            blackboardFormConst[input.name] = input.value;
        }
        setBlackboardForm(blackboardFormConst);
    };

    const handleCanvasFormChange = (e) => {
        const input = e.currentTarget;
        const canvasFormConst = Object.assign({}, canvasForm);
        if (input.type === "checkbox") {
            canvasFormConst[input.name] = input.checked;
        } else {
            canvasFormConst[input.name] = input.value;
        }
        setCanvasForm(canvasFormConst);
    };

    const handleD2lFormChange = (e) => {
        const input = e.currentTarget;
        const d2lFormConst = Object.assign({}, d2lForm);
        if (input.type === "checkbox") {
            d2lFormConst[input.name] = input.checked;
        } else {
            d2lFormConst[input.name] = input.value;
        }
        setD2lForm(d2lFormConst);
    };

    const handleMoodleFormChange = (e) => {
        const input = e.currentTarget;
        const moodleFormConst = Object.assign({}, moodleForm);
        if (input.type === "checkbox") {
            moodleFormConst[input.name] = input.checked;
        } else {
            moodleFormConst[input.name] = input.value;
        }
        setMoodleForm(moodleFormConst);
    };

    const getValueBlackboard = (element) => {
        if (element.display === LTI_USER_MAPPING.STUDENT) {
            return blackboardForm.studentRole
        } else if (element.display === LTI_USER_MAPPING.INSTRUCTOR) {
            return blackboardForm.instructorRole
        } else if (element.display === LTI_USER_MAPPING.GRADER) {
            return blackboardForm.graderRole
        } else if (element.display === LTI_USER_MAPPING.COURSE_BUILDER) {
            return blackboardForm.courseBuilderRole
        } else if (element.display === LTI_USER_MAPPING.TEACHING_ASSISTANT) {
            return blackboardForm.teachingAssistantRole
        } else if (element.display === LTI_USER_MAPPING.GUEST) {
            return blackboardForm.guestRole
        } else if (element.display === LTI_USER_MAPPING.ADMIN) {
            return blackboardForm.adminRole
        } else if (element.display === LTI_USER_MAPPING.OTHER) {
            return blackboardForm.otherRole
        }
    };

    const getValueCanvas = (element) => {
        if (element.display === LTI_USER_MAPPING.ADMIN) {
            return canvasForm.adminRole
        } else if (element.display === LTI_USER_MAPPING.STUDENT) {
            return canvasForm.studentRole
        } else if (element.display === LTI_USER_MAPPING.TEACHER) {
            return canvasForm.teacherRole
        } else if (element.display === LTI_USER_MAPPING.TEACHING_ASSISTANT) {
            return canvasForm.teachingAssistantRole
        } else if (element.display === LTI_USER_MAPPING.DESIGNER) {
            return canvasForm.designerRole
        } else if (element.display === LTI_USER_MAPPING.OBSERVER) {
            return canvasForm.observerRole
        }
    };

    const getValueMoodle = (element) => {
        if (element.display === LTI_USER_MAPPING.STUDENT_COURSE) {
            return moodleForm.studentRole
        } else if (element.display === LTI_USER_MAPPING.TEACHER_MANAGER) {
            return moodleForm.instructorRole
        } else if (element.display === LTI_USER_MAPPING.ADMIN) {
            return moodleForm.adminRole
        }
    };

    const getValueD2L = (element) => {
        if (element.display === LTI_USER_MAPPING.STUDENT_COURSE) {
            return d2lForm.studentRole
        } else if (element.display === LTI_USER_MAPPING.INSTRUCTOR) {
            return d2lForm.instructorRole
        } else if (element.display === LTI_USER_MAPPING.ADMIN) {
            return d2lForm.adminRole
        }
    };

    const callUpdateFunction = (e) => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            handleBlackboardFormChange(e);
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            handleCanvasFormChange(e);
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            handleMoodleFormChange(e);
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            handleD2lFormChange(e);
        }
    };

    const onSwitch = (name, checked) => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            const blackboardFormCopy = Object.assign({}, blackboardForm);
            blackboardFormCopy[name] = checked;
            setBlackboardForm(blackboardFormCopy);
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            const canvasFormCopy = Object.assign({}, canvasForm);
            canvasFormCopy[name] = checked;
            setCanvasForm(canvasFormCopy);
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            const moodleFormCopy = Object.assign({}, moodleForm);
            moodleFormCopy[name] = checked;
            setMoodleForm(moodleFormCopy);
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            const d2lFormCopy = Object.assign({}, d2lForm);
            d2lFormCopy[name] = checked;
            setD2lForm(d2lFormCopy);
        }
    }

    const getForm = () => {
        if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD) {
            return blackboardForm;
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS) {
            return canvasForm;
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE) {
            return moodleForm;
        } else if (selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L) {
            return d2lForm;
        }
    };

    const renderLtiField = (field, name) => (
        <Fragment key={name}>
            <div className={styles.fieldLabelCol}>
                <div className={styles.fieldLabelRow}>
                    {field.label}
                    <YuJaTooltip placement="bottom" text={field.getTooltip(selectedMenu)} tooltipStyle={{maxWidth: 320}}>
                        <InfoIcon className={styles.infoIcon}/>
                    </YuJaTooltip>
                </div>
                <div className={styles.fieldDescription}>{field.description}</div>
            </div>
            <YuJaTextBox
                label={field.placeholder + INTEG_TEXT_BOX}
                placeholder={field.placeholder}
                name={name}
                value={getForm()[name]}
                containerStyle={{fontSize: 14, lineHeight: 1.6, width: "100%"}}
                onChange={callUpdateFunction}
                isInvalid={!isFieldFilled(getForm()[name])}
                limitedSpace={false}
                errorMsg={field.errorMsg}
            />
        </Fragment>
    );


    return (
        <div style={{display: "flex", flexDirection: "row", gap: 20, flexWrap: "wrap", marginTop: 20}}>
            <Card className={styles.smallBox} style={{minWidth: 550, height: "fit-content"}}>
                <Card.Header style={{
                    minHeight: 52,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexWrap: "wrap",
                    gap: 5
                }}>
                    <div style={{display: "flex", alignItems: "center"}}>
                        <img src={crossIntegrationLTI} alt="CrossIntegrationLTI" width={"24px"} height={"24px"}/>
                        <span className={styles.cardHeader}>{"LTI 1.3 Integrations"}</span>
                    </div>
                    {!loading && !!launchCountLoaded && !!isLTICompleted && !!launchCount &&
                        <div style={{display: "flex", alignItems: "center", gap: 5}}>
                            <CHECK/>
                            <span style={{fontSize: 14}}>{"LTI Launch detected in the last 24 hours."}</span>
                        </div>
                    }

                    {!loading && !!launchCountLoaded && !!isLTICompleted && !launchCount &&
                        <div style={{display: "flex", alignItems: "center", gap: 5}}>
                            <INFO/>
                            <span style={{fontSize: 14}}>{"LTI Launch not detected in the last 24 hours."}</span>
                        </div>
                    }


                </Card.Header>
                <Card.Body>
                    {!loading && INTEGRATION_GUIDE[getIntegrationType()] &&
                        <div className={styles.cardDescription}>
                            {INTEGRATION_GUIDE[getIntegrationType()].ltiIntegrationGuide.description}{" "}
                            <a
                                href={INTEGRATION_GUIDE[getIntegrationType()].ltiIntegrationGuide.linkUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                                className={styles.link}
                            >
                                {INTEGRATION_GUIDE[getIntegrationType()].ltiIntegrationGuide.linkText}
                            </a>
                            {". "}
                            {INTEGRATION_GUIDE[getIntegrationType()].ltiIntegrationGuide.suffix}
                        </div>
                    }
                    <Form className={styles.ltiFieldsGrid}>
                        {!loading &&
                            <>
                                {renderLtiField(LTI_FORM_FIELDS.ISS, "iss")}
                                {renderLtiField(LTI_FORM_FIELDS.CLIENT_ID, "clientId")}
                                {renderLtiField(LTI_FORM_FIELDS.DEPLOYMENT, "deploymentId")}
                                {renderLtiField(LTI_FORM_FIELDS.OIDC, "oidcEndpoint")}
                                {renderLtiField(LTI_FORM_FIELDS.JWKS, "jwksEndpoint")}
                                {renderLtiField(LTI_FORM_FIELDS.OAUTH, "oAuth2Endpoint")}
                            </>
                        }
                        {loading &&
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                <div style={{display: "flex", flexDirection: "column", gridColumn: "1 / -1"}}>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 42}}/>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 42}}/>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 42}}/>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 42}}/>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 42}}/>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 42}}/>
                                </div>
                            </SkeletonTheme>
                        }
                    </Form>
                </Card.Body>
            </Card>

            <div style={{display: "flex", flexDirection: "column", gap: 20, flex: 1, minWidth: 550,}}>
                <Card className={styles.smallBox}>
                    <Card.Header style={{height: 52, display: "flex", alignItems: "center"}}>
                        <img src={roleMapping} alt="RoleMapping" width={"24px"} height={"24px"}/>
                        <span className={styles.cardHeader}>User {ROLE_MAPPING}</span>
                    </Card.Header>
                    <Card.Body>
                        <div style={{display: "grid", gridTemplateColumns: "1fr auto 1fr", gap: 10, alignItems: "center"}}>
                            <div className="form-labelReg" style={{position: "relative", height: "100%"}}>
                                <span style={{
                                    position: "absolute",
                                    top: 0,
                                    left: 0,
                                    whiteSpace: "nowrap"
                                }}>{selectedMenu} Course Role</span>
                            </div>
                            <div style={{width: 32}}/>
                            <div style={{fontWeight: "700", fontSize: 15, width: 150, justifySelf: "end"}}>YuJa Role</div>
                        </div>

                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD && !loading &&
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "auto 1fr auto",
                                gap: 10,
                                alignItems: "center",
                                marginTop: 10
                            }}>
                                {blackboardRoles.map(element =>
                                    <Fragment key={element.display}>
                                        {element.display === LTI_USER_MAPPING.ADMIN &&
                                            <Fragment>
                                                <div className="form-label" style={{position: "relative", height: "100%"}}>
                                      <span style={{
                                          position: "absolute",
                                          top: 0,
                                          left: 0,
                                          whiteSpace: "nowrap"
                                      }}>{selectedMenu} System Role</span>
                                                </div>
                                                <div style={{width: 32}}/>
                                                <div style={{fontWeight: "700", fontSize: 15, width: 150}}>YuJa Role</div>
                                            </Fragment>
                                        }
                                        <Fragment>
                                            <div className={styles.labelDesc}>{element.display}</div>
                                            <img src={LTiIcon} alt="LTiIcon" width={"32px"} height={"32px"}
                                                 style={{justifySelf: "center"}}/>
                                            <YuJaDropdown
                                                placeholder={"Select Role"}
                                                containerStyle={{width: 150}}
                                                data={Object.values(CREATION_ROLES)}
                                                value={getValueBlackboard(element)}
                                                getOptionLabel={item => item.display}
                                                onChange={item => {
                                                    const e = {currentTarget: {value: item.value, name: element.value}};
                                                    handleBlackboardFormChange(e);
                                                }}
                                            />
                                        </Fragment>
                                    </Fragment>
                                )}
                            </div>
                        }
                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.BLACKBOARD && loading &&
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                {blackboardRoles.map(element =>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                                )}
                            </SkeletonTheme>
                        }
                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS && !loading &&
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "auto 1fr auto",
                                gap: 10,
                                alignItems: "center",
                                marginTop: 10
                            }}>
                                {canvasRoles.map(element =>
                                    <Fragment key={element.display}>
                                        <div className={styles.labelDesc}>{element.display}</div>
                                        <img src={LTiIcon} alt="LTiIcon" width={"32px"} height={"32px"}
                                             style={{justifySelf: "center"}}/>
                                        <YuJaDropdown
                                            placeholder={"Select Role"}
                                            containerStyle={{width: 150}}
                                            data={Object.values(CREATION_ROLES)}
                                            value={getValueCanvas(element)}
                                            getOptionLabel={item => item.display}
                                            onChange={item => {
                                                const e = {currentTarget: {value: item.value, name: element.value}};
                                                handleCanvasFormChange(e);
                                            }}
                                        />
                                    </Fragment>
                                )}
                            </div>
                        }
                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.CANVAS && loading &&
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                {canvasRoles.map(element =>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                                )}
                            </SkeletonTheme>
                        }
                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE && !loading &&
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "auto 1fr auto",
                                gap: 10,
                                alignItems: "center",
                                marginTop: 10
                            }}>
                                {moodleRoles.map(element =>
                                    <Fragment key={element.display}>
                                        <div className={styles.labelDesc}>{element.display}</div>
                                        <img src={LTiIcon} alt="LTiIcon" width={"32px"} height={"32px"}
                                             style={{justifySelf: "center"}}/>
                                        <YuJaDropdown
                                            placeholder={"Select Role"}
                                            containerStyle={{width: 150}}
                                            data={Object.values(CREATION_ROLES)}
                                            value={getValueMoodle(element)}
                                            getOptionLabel={item => item.display}
                                            onChange={item => {
                                                const e = {currentTarget: {value: item.value, name: element.value}};
                                                handleMoodleFormChange(e);
                                            }}
                                        />
                                    </Fragment>
                                )}
                            </div>
                        }
                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.MOODLE && loading &&
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                {moodleRoles.map(element =>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                                )}
                            </SkeletonTheme>
                        }
                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L && !loading &&
                            <div style={{
                                display: "grid",
                                gridTemplateColumns: "auto 1fr auto",
                                gap: 10,
                                alignItems: "center",
                                marginTop: 10
                            }}>
                                {d2lRoles.map(element =>
                                    <Fragment key={element.display}>
                                        <div className={styles.labelDesc}>{element.display}</div>
                                        <img src={LTiIcon} alt="LTiIcon" width={"32px"} height={"32px"}
                                             style={{justifySelf: "center"}}/>
                                        <YuJaDropdown
                                            placeholder={"Select Role"}
                                            containerStyle={{width: 150}}
                                            data={Object.values(CREATION_ROLES)}
                                            value={getValueD2L(element)}
                                            getOptionLabel={item => item.display}
                                            onChange={item => {
                                                const e = {currentTarget: {value: item.value, name: element.value}};
                                                handleD2lFormChange(e);
                                            }}
                                        />
                                    </Fragment>
                                )}
                            </div>
                        }
                        {selectedMenu === INTEGRATION_TYPES_LOWERCASE.D2L && loading &&
                            <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                {d2lRoles.map(element =>
                                    <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 20}}/>
                                )}
                            </SkeletonTheme>
                        }
                    </Card.Body>
                </Card>
                <Card className={styles.smallBox}>
                    <Card.Header style={{height: 52, display: "flex", alignItems: "center"}}>
                        <img src={userProvisioning} alt="User Provisioning" width={"24px"} height={"24px"}/>
                        <span className={styles.cardHeader}>{USER_CONFIG}</span>
                        <span></span>
                    </Card.Header>
                    <Card.Body>
                        <Form>
                            {!loading &&
                                <>
                                    <Form.Group controlId="autoProvisionUser" className={styles.toggleRow}>
                                        <div className={styles.toggleTextRow}>
                                            <div>{AUTO_PROVISION_USER}</div>
                                            <div
                                                className={styles.toggleDescriptionText}>{AUTO_PROVISION_USER_DESC}</div>
                                        </div>
                                        <YuJaSwitch
                                            aria-label={AUTO_PROVISION_USER}
                                            checked={true}
                                            disabled={true}
                                            onChange={checked => onSwitch("autoProvisionUser", checked)}
                                        />
                                        {/*<YuJaToggle name="autoProvisionUser" disabled={true} toggled={true}*/}
                                        {/*            onClick={callUpdateFunction}/>*/}
                                    </Form.Group>

                                    <Form.Group controlId="autoSyncData" className={styles.toggleRow}>
                                        <div className={styles.toggleTextRow}>
                                            <div>{AUTO_SYNC_USER}</div>
                                            <div className={styles.toggleDescriptionText}>{AUTO_SYNC_USER_DESC}</div>
                                        </div>

                                        <YuJaSwitch
                                            aria-label={AUTO_SYNC_USER}
                                            checked={getForm().autoSyncData}
                                            onChange={checked => onSwitch("autoSyncData", checked)}
                                        />
                                        {/*<YuJaToggle name="autoSyncData" toggled={getForm().autoSyncData}*/}
                                        {/*            onClick={callUpdateFunction}/>*/}
                                    </Form.Group>
                                </>
                            }
                            {loading &&
                                <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 5}}/>
                                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 5}}/>
                                    </div>
                                </SkeletonTheme>
                            }
                        </Form>
                    </Card.Body>
                </Card>
                <Card className={styles.smallBox}>
                    <Card.Header style={{height: 52, display: "flex", alignItems: "center"}}>
                        <img src={generalIcon} alt="CourseConfig" width={"24px"} height={"24px"}/>
                        <span className={styles.cardHeader}>{COURSE_CONFIG}</span>
                    </Card.Header>
                    <Card.Body>
                        <Form>
                            {!loading &&
                                <>
                                    <Form.Group controlId="autoProvisionCourse" className={styles.toggleRow}>
                                        <div className={styles.toggleTextRow}>
                                            <div>{AUTO_PROVISION_COURSE}</div>
                                            <div
                                                className={styles.toggleDescriptionText}>{AUTO_PROVISION_COURSE_DESC}</div>
                                        </div>

                                        <YuJaSwitch
                                            aria-label={AUTO_PROVISION_COURSE}
                                            checked={true}
                                            disabled={true}
                                            onChange={checked => onSwitch("autoProvisionCourse", checked)}
                                        />
                                        {/*<YuJaToggle name="autoProvisionCourse" toggled={true}*/}
                                        {/*            onClick={callUpdateFunction} disabled={true}/>*/}
                                    </Form.Group>
                                    <Form.Group controlId="autoSyncCourseData" className={styles.toggleRow}>
                                        <div className={styles.toggleTextRow}>
                                            <div>{AUTO_SYNC_COURSE}</div>
                                            <div className={styles.toggleDescriptionText}>{AUTO_SYNC_COURSE_DESC}</div>
                                        </div>
                                        <YuJaSwitch
                                            aria-label={AUTO_SYNC_COURSE}
                                            checked={getForm().autoSyncCourseData}
                                            onChange={checked => onSwitch("autoSyncCourseData", checked)}
                                        />
                                        {/*<YuJaToggle name="autoSyncCourseData" toggled={getForm().autoSyncCourseData}*/}
                                        {/*            onClick={callUpdateFunction}/>*/}
                                    </Form.Group>
                                </>
                            }
                            {
                                loading && <SkeletonTheme color="rgba(237, 237, 237, 1)" highlightColor="lightgrey">
                                    <div style={{display: "flex", flexDirection: "column"}}>
                                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 5}}/>
                                        <Skeleton height={37} borderRadius={10} inline={true} style={{marginTop: 5}}/>
                                    </div>
                                </SkeletonTheme>
                            }
                        </Form>
                    </Card.Body>
                </Card>
            </div>
        </div>
    );
}
